import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import classnames from 'classnames'
import PlanRadioButton from './PlanRadioButton'

import BillingStore from '../../../stores/billing'

// const plans = {
//   basic: 'Standard',
//   premium: 'Premium'
// }

const rates = {
  monthly: 'Monthly',
  yearly: 'Yearly'
}

@inject('auth')
@observer
class TwoToThree extends Component {
  state = {
    store: new BillingStore(),
    processing: false,
    selected_plan: null,
    selected_rate: null,
    started: false,
    completed: false,
    discounted: false,
  }

  componentWillMount() {
    this.state.store.loadCustomer()
    this.state.store.loadLicense().then(() => {
      const { license: { plan, rate } } = this.state.store
      this.setState({ selected_plan: plan, selected_rate: rate })
    })
  }

  yearlySavings() {
    const { license, license: { plan } } = this.state.store
    const { rates } = license.invoice_breakdown

    const monthly = rates.find(r => r.plan === `${plan}_monthly`)
    const yearly = rates.find(r => r.plan === `${plan}_yearly`)

    return (monthly.cost * 12) - yearly.cost
  }

  planPrice(plan) {
    const { store: { license }, selected_rate } = this.state
    const { rates } = license.invoice_breakdown

    if (!selected_rate) return 0
    return rates.find(r => r.plan === `${plan}_${selected_rate}`).cost
  }

  handlePlanChange = e => {
    const input = e.target
    const other = input.value === 'basic' ? 'premium' : 'basic'
    const plan = input.checked ? input.value : other

    let confirmed = true
    if (plan === 'basic') {
      confirmed = confirm('This will reset any Premium Settings. Are you sure?')
    }
    if (confirmed) {
      this.setState({ selected_plan: plan })
    }
  }

  handleRateChange = e => {
    const input = e.target
    const other = input.value === 'monthly' ? 'yearly' : 'monthly'
    const rate = input.checked ? input.value : other
    this.setState({ selected_rate: rate })
  }

  handleTwoToThreeDiscount = e => {
    e.preventDefault()
    if (confirm('Please confirm you want Premium Yearly with the $100 Coupon.')) {
      this.setState({ processing: true })
      this.state.store.apply_2to3_discount().then(() => {
        this.props.auth.user.migration_status = 'migrated_decided'
        this.setState({ processing: false, completed: true, discounted: true, selected_plan: 'premium', selected_rate: 'yearly' })
      })
    }
  }

  handleDecision = e => {
    const { store, selected_plan, selected_rate } = this.state
    
    // If they chose premium yearly without the coupon like some
    // fucking morons. Let's still give them the discount.
    if (selected_plan === 'premium' && selected_rate === 'yearly') {
      return this.handleTwoToThreeDiscount(e)
    }
    
    // Otherwise process as normal.
    e.preventDefault()
    if (confirm('Please confirm you want to use the plan you have selected.')) {
      this.setState({ processing: true })
      store.updateLicense({
        ...this.state.store.license,
        plan: `${selected_plan}_${selected_rate}`,
        migration_status: 'migrated_decided',
      }).then(() => {
        this.props.auth.user.migration_status = 'migrated_decided'
        this.setState({ processing: false, completed: true })
      })
    }
  }

  handleStart = e => {
    e.preventDefault()
    this.setState({ started: true })
  }

  renderDiscountButton() {
    const { store: { license } } = this.state
    let action
    if (license.plan === 'premium' && license.rate === 'yearly') {
      action = 'Keep your current plan'
    } else {
      action = 'Switch to Premium Yearly'
    }
    action += ' for $899 the first year and $999/year after that.'

    return (
      <div className="panel full padded">
        <h2 className="title">{action}</h2>
        <button onClick={this.handleTwoToThreeDiscount}>Confirm Premium Yearly with $100 Coupon</button>
      </div>
    )
  }

  getProjectedItems() {
    const { store: { license: { invoice_breakdown } }, selected_plan, selected_rate, discounted } = this.state

    return invoice_breakdown.items.map(item => {
      if (item.plan.match(/^(?:basic|premium)_(?:monthly|yearly)$/)) {
        const found = { ...invoice_breakdown.rates.find(r => r.plan === `${selected_plan}_${selected_rate}`) }
        if (discounted) {
          found.cost = found.cost - 100
        }
        return found
      } else if (item.plan.match(/_yearly$/) && selected_rate === 'monthly') {
        return {
          ...item, plan: item.plan.replace(/_yearly$/, '_monthly'), cost: item.cost / 12, name: item.name.replace(rates.yearly, rates.monthly)
        }
      } else if (item.plan.match(/_monthly$/) && selected_rate === 'yearly') {
        return {
          ...item, plan: item.plan.replace(/_monthly$/, '_yearly'), cost: item.cost * 12, name: item.name.replace(rates.monthly, rates.yearly)
        }
      } else {
        return { ...item }
      }
    })
  }

  renderSummary() {
    const { selected_plan, selected_rate } = this.state

    if (selected_plan && selected_rate) {
      const items = this.getProjectedItems()
      const total = items.reduce((t, i) => {
        return t + (i.cost * (i.quantity || 1))
      }, 0)

      return (
        <div>
          <h2 className="title">Billing Summary</h2>
          <table>
            <tbody>
              {items.map(item => (
                <tr key={item.plan}>
                  <td style={{ padding: '5px 0' }}>{item.name}{item.quantity > 1 ? ` (${item.quantity} @ $${item.cost.toFixed(2)} ea.)` : null}</td>
                  <td style={{ padding: '5px 0', textAlign: 'right' }}>${(item.cost * (item.quantity || 1)).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '10px', paddingTop: '10px', fontWeight: 'bold', textAlign: 'right', borderTop: '1px solid #eee' }}>{rates[selected_rate]} Total: ${total.toFixed(2)}</div>
        </div>
      )
    }
  }

  renderPre() {
    return (
      <div className="container centered padded subscribe">
        <div className="panel full padded" style={{ textAlign: 'center' }}>
          <h2 className="title">End of Free Premium Trial Period For 2.0 Customers</h2>
          <p>
            As part of the upgrade from Showcase IDX 2.0 to 3.0 we gave you an introductory
            60 free days of Premium...
            <strong>that was over 300 days ago.</strong>
          </p>
          <hr />
          <h3>This free trial period is ending on 7/1/2018.</h3>
          <p className="muted">
            If you do nothing, you will stay on the Essentials plan at $59.95/mo which is the
            same base price, with more functionality, as what you had in 2.0, but will lose
            access to Showcase IDX's Premium Features and Settings.
          </p>
          <form>
            <button className="button success block big" onClick={this.handleStart}>
              Continue
            </button>
          </form>
        </div>

      </div>
    )
  }

  renderPost() {
    return (
      <div style={{ width: '100%' }}>
      <div className="container centered padded subscribe" style={{ paddingBottom: 0 }}>
        <div className="panel full padded" style={{ textAlign: 'center', marginBottom: 0 }}>
          <h2 className="title">Thank you for confirming your plan!</h2>
          <p>We really appreciate you being a Showcase IDX customer!</p>
          <br />
          <p><strong>We will be adjusting your plan and billing within the next 24 hours.</strong></p>
        </div>
      </div>
      <div className="container centered padded subscribe" style={{ paddingTop: 0 }}>
        <div style={{ background: '#7ED321', width: '100%', padding: '50px' }}>
          <div style={{ background: 'white', padding: '25px' }}>
            {this.renderSummary()}
          </div>
        </div>
      </div>
      </div>
    )
  }

  render() {
    const { store: { customer, license }, processing, selected_plan, selected_rate, started, completed } = this.state
    if (!customer || !license) return <div className="loading">Loading...</div>

    if (completed) {
      return this.renderPost()
    } else if (!started) {
      return this.renderPre()
    }

    return (
      <div style={{ width: '100%' }}>
      <div className="container centered padded subscribe">

        <div className="panel full padded" style={{ marginBottom: 0 }}>
          <h1 className="title" style={{ textAlign: 'center' }}>Get an extra $100 off of Premium Yearly!</h1>
          <p style={{ textAlign: 'center' }}>
            Choose a Premium Yearly Plan right now to get an additional $100 on top of the
            standard yearly $200 discount for your first year! Only $899 for the 1st year!
          </p>
          <form>
          <button className="button success block big" disabled={processing} onClick={this.handleTwoToThreeDiscount}>
            <i className={classnames('fa', {
              'fa-check': !processing,
              'fa-spinner': processing,
              'fa-spin': processing,
            })} />
            &nbsp; Select Premium Yearly Plan with a special $300 first year discount
          </button>
          </form>
        </div>

      </div>
      <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.2em' }} >or</div>
      <div className="container centered padded subscribe">

        <div className="panel full padded">
          <h1 className="title" style={{ textAlign: 'center' }}>Confirm Your Plan</h1>
          <p style={{ textAlign: 'center' }}>This new plan will start immediately.</p>
          <br />
          
          <div style={{ display: 'flex' }}>
            <div style={{ flex: '1 1 100%' }}>
              <h3 className="title">Choose Your Plan</h3>
              <PlanRadioButton
                selected={selected_plan === 'premium'}
                disabled={processing}
                onChange={this.handlePlanChange}
                name="plan"
                value="premium"
                primaryLeft={<span>Premium <em>Recommended</em></span>}
                primaryRight={`$${this.planPrice('premium').toFixed(2)}/${selected_rate === 'monthly' ? 'mo' : 'yr'}.`}
                secondaryLeft="More Settings + Premium Listing Content + Lead Routing + More" />
              <PlanRadioButton
                selected={selected_plan === 'basic'}
                disabled={processing}
                onChange={this.handlePlanChange}
                name="rate"
                value="basic"
                primaryLeft="Essentials"
                primaryRight={`$${this.planPrice('basic').toFixed(2)}/${selected_rate === 'monthly' ? 'mo' : 'yr'}.`}
                secondaryLeft="Everything you need to engage consumers on your website." />
            </div>
            <div style={{ flex: '1 1 100%', marginLeft: '15px' }}>
              <h3 className="title">Billing Frequency</h3>
              <PlanRadioButton
                selected={selected_rate === 'yearly'}
                disabled={processing}
                onChange={this.handleRateChange}
                name="rate"
                value="yearly"
                primaryLeft={<span>Yearly <em>Recommended</em></span>}
                primaryRight={<strong>Save ${this.yearlySavings().toFixed(2)}</strong>}
                secondaryLeft="Pay up front and save!"
                secondaryRight="Per year on the Premium Plan" />
              <PlanRadioButton
                selected={selected_rate === 'monthly'}
                disabled={processing}
                onChange={this.handleRateChange}
                name="rate"
                value="monthly"
                primaryLeft="Monthly"
                secondaryLeft="Pay-as-you-go." />
            </div>
          </div>

        </div>

        <div className="panel full padded">
          {this.renderSummary()}
          <form>
            <button className="button success block big" disabled={processing} onClick={this.handleDecision}>
              <i className={classnames('fa', {
                'fa-check': !processing,
                'fa-spinner': processing,
                'fa-spin': processing,
              })} />
              &nbsp; Confirm Subscription
            </button>
          </form>
        </div>

      
      </div>
      </div>
    )
  }
}

export default TwoToThree



// WEBPACK FOOTER //
// client/components/sections/Billing/TwoToThree.js